<template>
  <div class="page-wrapper">
      <div class="content container-fluid">

    <div v-if="isLoading" class="text-center py-5">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
      <p class="mt-2">Đang tải dữ liệu hành trình...</p>
    </div>

    <div v-else-if="error" class="alert alert-danger">{{ error }}</div>

    <div v-else-if="hanhTrinh">
      <!-- Thông tin xe -->
      <div class="card shadow-sm mb-3">
        <div class="card-body d-flex justify-content-between align-items-center">
          <div>
            <h5 class="mb-1">
              <i class="fa fa-truck text-primary mr-2"></i>{{ hanhTrinh.bienSo }}
            </h5>
            <p class="mb-0 text-muted small">
              <i class="fa fa-user mr-1"></i>{{ hanhTrinh.taiXe || "Chưa phân công" }}
            </p>
            <span class="badge badge-info">{{ hanhTrinh.trangThai }}</span>
          </div>
          <button class="btn btn-outline-secondary btn-sm" @click="fetchData">
            <i class="fa fa-sync" :class="{ 'fa-spin': isLoading }"></i> Làm mới
          </button>
        </div>
      </div>

      <!-- GPS hiện tại -->
      <div v-if="hanhTrinh.gps" class="alert alert-light border">
        <i class="fa fa-map-marker-alt text-danger"></i>
        <strong> Vị trí:</strong> {{ hanhTrinh.gps.address }} <br />
        <small class="text-muted">
          Tốc độ: {{ hanhTrinh.gps.speed }} km/h |
          Lat: {{ hanhTrinh.gps.lat }}, Lng: {{ hanhTrinh.gps.lng }}
        </small>
      </div>

      <!-- Đơn hàng đang vận chuyển -->
      <div v-for="don in hanhTrinh.donDangChay" :key="don.donHangId" class="card mb-3 shadow-sm">
        <div class="card-header bg-primary text-white py-2">
          <strong>{{ don.tenDonHang }}</strong>
          <span class="badge badge-light text-primary float-right">{{ don.trangThai }}</span>
        </div>
        <div class="card-body p-2">
          <table class="table table-sm table-bordered mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Điểm dừng</th>
                <th>Địa chỉ</th>
                <th>Trạng thái</th>
                <th>Khoảng cách</th>
                <th>ETA</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="dd in don.diemDung" :key="dd.id">
                <td>{{ dd.thuTu }}</td>
                <td>{{ dd.tenDiemDung }}</td>
                <td>{{ dd.diaChi }}</td>
                <td>
                  <span :class="badgeClass(dd.trangThai)">{{ dd.trangThai }}</span>
                </td>
                <td>{{ dd.distanceKm ? dd.distanceKm.toFixed(1) + ' km' : '-' }}</td>
                <td>{{ dd.etaMinutes ? dd.etaMinutes + ' phút' : '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { XeApi } from "@/services/xeService";

export default {
  name: "XeHanhTrinhView",
  props: {
    xeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      hanhTrinh: null,
      isLoading: false,
      error: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      this.error = null;
      try {
        this.hanhTrinh = await XeApi.getHanhTrinh(1);
      } catch (err) {
        this.error = "Không tải được dữ liệu hành trình.";
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    badgeClass(status) {
      switch (status) {
        case "CHO_SOAN_HANG":
          return "badge badge-secondary";
        case "DANG_VAN_CHUYEN":
          return "badge badge-primary";
        case "HOAN_THANH":
          return "badge badge-success";
        case "THAT_BAI":
          return "badge badge-danger";
        default:
          return "badge badge-light";
      }
    },
  },
};
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle !important;
}
</style>
